var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-usages-list',{attrs:{"show-no-energy":"","organization-id":_vm.organization?.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }